import React from 'react';
export function ContributionGraph() {
  // Generate a grid of contribution levels (0-4)
  // 0: #ebedf0 (bg)
  // 1: #9be9a8
  // 2: #40c463
  // 3: #30a14e
  // 4: #216e39
  const colors = ['bg-[#ebedf0]', 'bg-[#9be9a8]', 'bg-[#40c463]', 'bg-[#30a14e]', 'bg-[#216e39]' // Level 4
  ];
  // Create a deterministic but random-looking pattern
  const generateGrid = () => {
    const grid = [];
    for (let i = 0; i < 7; i++) {
      // 7 days/rows
      const row = [];
      for (let j = 0; j < 40; j++) {
        // 40 weeks/cols (reduced for mobile/tablet fit)
        // More activity in the middle/recent columns
        const random = Math.random();
        let level = 0;
        if (random > 0.85) level = 4;else if (random > 0.65) level = 3;else if (random > 0.4) level = 2;else if (random > 0.2) level = 1;
        // Make some empty patches
        if (Math.random() > 0.7 && level > 0) level = 0;
        row.push(level);
      }
      grid.push(row);
    }
    return grid;
  };
  const grid = generateGrid();
  return <div className="flex flex-col gap-1 overflow-hidden opacity-80 hover:opacity-100 transition-opacity duration-500" data-id="element-40">
      {grid.map((row, rowIndex) => <div key={rowIndex} className="flex gap-1" data-id="element-41">
          {row.map((level, colIndex) => <div key={`${rowIndex}-${colIndex}`} className={`w-2.5 h-2.5 rounded-[2px] ${colors[level]}`} title={`Contribution level ${level}`} data-id="element-42" />)}
        </div>)}
      <div className="flex items-center justify-end gap-1 mt-2 text-xs text-[#57606a]" data-id="element-43">
        <span data-id="element-44">Less</span>
        <div className="w-2.5 h-2.5 rounded-[2px] bg-[#ebedf0]" data-id="element-45"></div>
        <div className="w-2.5 h-2.5 rounded-[2px] bg-[#9be9a8]" data-id="element-46"></div>
        <div className="w-2.5 h-2.5 rounded-[2px] bg-[#40c463]" data-id="element-47"></div>
        <div className="w-2.5 h-2.5 rounded-[2px] bg-[#30a14e]" data-id="element-48"></div>
        <div className="w-2.5 h-2.5 rounded-[2px] bg-[#216e39]" data-id="element-49"></div>
        <span data-id="element-50">More</span>
      </div>
    </div>;
}